import type {RuleValidationErrors} from '../types';
import type {FileFormatRule} from './types';

export const validateFileFormatRule = <
	T extends FileFormatRule = FileFormatRule,
>(
	rule: T,
): RuleValidationErrors | false => {
	// no validation at this time
	return false;
};

export default validateFileFormatRule;
